import { LinksGroup } from "./NavbarLinksGroup/NavbarLinksGroup";
import { useLanguage } from "../../stores/LanguageStore";
import { getPermission } from "../../functions/utilFunctions";
import { Box, rem, ThemeIcon } from "@mantine/core";
import IconSubscription from "../../assets/icons/IconSubscription";
import { useSessionStore } from "../../stores/UserStore";

const PricingComponent = ({ closed }) => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);

  const main = closed ? (
    <Box pos={"relative"}>
      <LinksGroup
        id={"subscription"}
        path={reseller?.pricing_url || "/settings/subscription"}
        target={reseller?.pricing_url ? "_blank" : undefined}
        name={lang.pricing.browser_tab_title}
        navbarClosed={closed}
        isPricing={true}
        customIcon={
          <ThemeIcon variant={"subtle"} size={32}>
            <IconSubscription
              style={{
                width: rem(20),
                height: rem(20),
                marginRight: -4,
              }}
            />
          </ThemeIcon>
        }
      />
    </Box>
  ) : (
    <LinksGroup
      id={"subscription"}
      path={reseller?.pricing_url || "/settings/subscription"}
      target={reseller?.pricing_url ? "_blank" : undefined}
      name={lang.pricing.browser_tab_title}
      isPricing={true}
      innerStyle={{
        padding: "8px 0 8px 8px",
      }}
      customIcon={
        <ThemeIcon variant={"subtle"}>
          <IconSubscription
            style={{
              width: rem(20),
              height: rem(20),
            }}
          />
        </ThemeIcon>
      }
    />
  );

  if (getPermission("displayPricing")) {
    return main;
  }
  return "";
};

export default PricingComponent;
